export const addonReasons = [
  { id: 'alternative_payment', name: 'Альтернативная оплата' },
  { id: 'academy_admin', name: 'Админ академии' },
  { id: 'promo', name: 'Промо' },
];
